module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('van-tabbar', {
    staticClass: "main-tab",
    attrs: {
      "route": "",
      "active-color": "#557ff9",
      "inactive-color": "#8b8b8d"
    },
    model: {
      value: (_vm.active),
      callback: function($$v) {
        _vm.active = $$v
      },
      expression: "active"
    }
  }, _vm._l((_vm.tabbars), function(item, index) {
    return _c('van-tabbar-item', {
      key: index,
      attrs: {
        "replace": "",
        "to": item.path
      },
      scopedSlots: _vm._u([{
        key: "icon",
        fn: function(props) {
          return [_c('img', {
            attrs: {
              "src": props.active ? item.active : item.inactive
            }
          })]
        }
      }], null, true)
    }, [_c('span', [_vm._v(_vm._s(item.text))])])
  }), 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/_vue-loader@11.3.4@vue-loader/lib/template-compiler?{"id":"data-v-4bfd538d"}!./~/_vue-loader@11.3.4@vue-loader/lib/selector.js?type=template&index=0!./src/components/tabbar.vue
// module id = 696
// module chunks = 1